/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const termsOverlay = document.querySelector('.terms-overlay');
const termsContent = document.querySelector('.terms-content-wrapper');
const termsDeny = document.querySelector('.terms-deny');
const termsAccept = document.querySelector('.terms-accept');


function showTerms() {
    termsOverlay.classList.add('terms-overlay--active');
    termsContent.classList.add('terms-content-wrapper--active');
}

function hideTerms() {
    termsOverlay.classList.remove('terms-overlay--active');
    termsContent.classList.remove('terms-content-wrapper--active');
}
function validateTerms(e) {
    e.preventDefault();
    const cartTerms = document.querySelector('#cartTerms');

    if (cartTerms.checked) {
        window.location = '/checkout';
    } else {
        showTerms();
    }
}

termsOverlay.addEventListener('click', () => {
    hideTerms();
});

termsAccept.addEventListener('click', () => {
    window.location = '/checkout';
});

termsDeny.addEventListener('click', () => {
    hideTerms();
});

// GEO JS

const geoLinks = document.querySelectorAll(".geoLink");
const cookieOverlay = document.querySelector(".cookieOverlay");
const popup__Cookie = Cookies.get('countrySelector');
const FootercountrySelector = document.querySelector(".Footer__countrySelector");
const geoPopup = document.querySelector(".geoPopup");

console.log(popup__Cookie)

async function getIPLocation() {
    
    const config = {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
      },
    }
    const response = await fetch(`http://get.geojs.io/v1/ip/geo.json`, config)

    .then((res)=> res.status === 200 ?  res.json() : null)

    .then((data)=>{
        const countryCode = data.country_code.toLowerCase();

        if(popup__Cookie === undefined){
            geoPopup.style.display = "block";
            cookieOverlay.style.display = "block";
            geoPopup.classList.remove("hide");
            cookieOverlay.classList.remove("hide");
        }

        if(popup__Cookie != undefined){
            geoPopup.classList.add("hide");
            cookieOverlay.classList.add("hide");
        }

        if(window.location.href.includes("dk") && countryCode === 'dk'){
            geoPopup.classList.add("hide");
            cookieOverlay.classList.add("hide");
        }
    })
    .catch(error => console.error(error))
}

getIPLocation();


geoLinks.forEach(element => {
    element.addEventListener("click", ()=>{
        Cookies.set('countrySelector', element.href, { expires: 30 })
    })
});

FootercountrySelector.addEventListener("click", ()=>{
    geoPopup.classList.remove("hide");
    cookieOverlay.classList.remove("hide");
    geoPopup.style.display = "block";
    cookieOverlay.style.display = "block";
})